namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class ElPodaniListAC extends GContentBase<PodListBaseAC>
    {
        model: Gordic.Wfl.Client.GElPodaniPrehledFilterDto;

        onContentReady() {
            const that = this;
            PodListBaseAC.InitList(this);
            this.FrmFiltr = "el_pod";
            this.topActions.push(Wfl.ListAC.WflListBaseAC.CreateActionDetailDokSpis(this));
            this.specialActions.push(PodListBaseAC.CreateActionZobrazitZpravu(this, true));
            this.specialActions.push(PodListBaseAC.CreateActionUlozitZpravu(this, true));
            this.specialActions.push(this.CreateActionOdstornovatElPodani());
            this.specialActions.push(this.CreateActionVratitKeZpracovani());
            this.specialActions.push(this.CreateActionPuvodniVzhledlElPodani());
            this.specialActions.push(PodListBaseAC.CreateActionSloucitZpetRozlozena(this));
            this.specialActions.push(PodListBaseAC.CreateActionZobrazitPotvrzeniODoruceni(this));
            this.specialActions.push(PodListBaseAC.CreateActionOdemknoutElPodani(this));
            this.specialActions.push(this.CreateActionNastavitZpracovaniAutomat());
            this.specialActions.push(this.CreateActionNastavitZpracovaniManual());
            this.specialActions.push(PodListBaseAC.CreateActionAktualizaceMetadatOvereniElPodani(this));
            this.specialActions.push(PodListBaseAC.CreateActionOdeslatPotvrzeniODoruceni(this, true));
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    favorites: "all", 
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_prehep" }), 
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky"
                });

            this.CreateGrid();  
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni);
        }

        CreateFilterForms() {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "jres:23900223", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" })  //RC 23900223 : Kompletní filtr
                .addSection()
                .addRow({ label: "jres:23900016" }).addField("gselectbox", {
                    list: true,
                    name: "Stav",
                    data: new Gordic.Data.View([
                        { val: Wfl.Interface.StavElPodaniEnum.Vsechny, text: 'jres:23900004' }, //RC 23900004 : vše
                        { val: Wfl.Interface.StavElPodaniEnum.Nezpracovane, text: 'jres:23900040' }, //RC 23900040 : nezpracované
                        { val: Wfl.Interface.StavElPodaniEnum.Rozlozene, text: 'jres:23900041' }, //RC 23900041 : rozložené
                        { val: Wfl.Interface.StavElPodaniEnum.Stornovane, text: 'jres:23900042' }, //RC 23900042 : stornované
                        { val: Wfl.Interface.StavElPodaniEnum.Zpracovame, text: 'jres:23900043' }, //RC 23900043 : zpracované
                        { val: Wfl.Interface.StavElPodaniEnum.Podane, text: 'jres:23900044' },  //RC 23900044 : podané
                        { val: Wfl.Interface.StavElPodaniEnum.Odmitnute, text: 'jres:23900045' }, //RC 23900045 : odmítnuté
                    ], { key: "val" }),
                    itemTemplate: "{text}",
                    model: "model.Stav=value.val",
                    itemWidth: "",
                    initialValue: { val: this.model.Stav }, 
                })
                .addSection()
                .addPrefab(ListPrefabs.SekceFilterDlePodepsani({ initialValue: this.model.Podepsani } as GRadioOptions<any>))
                .addSection()
                //.addPrefab(ListPrefabs.SekceFilterDleZpusobuDoruceni({ ds: { model: "" } }))
                .addPrefab(ListPrefabs.SekceFilterDleZpusobuDoruceni({
                    email: { initialValue: this.model.TypPrijmu_EMail },
                    ElNosic: { initialValue: this.model.TypPrijmu_DatovyNosic },
                    DS: { initialValue: this.model.TypPrijmu_DS },
                    WebPodatelna: { initialValue: this.model.TypPrijmu_WebPodatelna },
                    GEX: { initialValue: this.model.TypPrijmu_GEX },
                    ostatni: { initialValue: this.model.TypPrijmu_Ostatni }
                }));

            filterForm
                .addSection()
                .addRow({ label: "jres:23900209" }).addField("gselectbox", { //RC 23900209 : Filtr dle datumu
                    list: true,
                    name: "FiltrDleDatumu",
                    data: new Gordic.Data.View([
                        { val: Wfl.Interface.TypFiltrDleDatumu.Dodani, text: 'jres:23900206' }, //RC 23900206 : dodání
                        { val: Wfl.Interface.TypFiltrDleDatumu.Stazeni, text: 'jres:23900207' }, //RC 23900207 : stažení
                        { val: Wfl.Interface.TypFiltrDleDatumu.Zpracovani, text: 'jres:23900208' }, //RC 23900208 : zpracování
                    ], { key: "val" }),
                    itemTemplate: "{text}",
                    model: "model.FiltrDleDatumu=value.val",                    
                    initialValue: { val: this.model.FiltrDleDatumu }, 
                    itemWidth: ""
                })
                .addField("gdatecombobox", {
                    name: "DatumField",
                    model: "model.Datum=value.date",
                    defaultInitialValue: "all",
                    daysRangeMax: this.DaysRangeMax,
                    contextMenu: {
                        daysRange: 50
                    },
                    userSettings: this.userSettings,
                });

            if (this.model.EpaAutomat) {
                filterForm.addRow({ label: "jres:23900212" }).addField("gselectbox", { //RC 23900212 : Zpracování
                    list: true,
                    name: "Zpracovani",
                    data: new Gordic.Data.View([
                        { val: Gordic.Wfl.Interface.FiltrDleZpracovaniEnum.Vsechny, text: 'jres:23900004' }, //RC 23900004 : vše
                        { val: Gordic.Wfl.Interface.FiltrDleZpracovaniEnum.Manual, text: 'jres:23900210' }, //RC 23900210 : manuální
                        { val: Gordic.Wfl.Interface.FiltrDleZpracovaniEnum.Automat, text: 'jres:23900211' }, //RC 23900211 : automatické
                    ], { key: "val" }),
                    itemTemplate: "{text}",
                    model: "model.Zpracovani=value.val",
                    initialValue: { val: this.model.Zpracovani },
                    itemWidth: "",
                })
            }
            return [filterForm];
        }

        CreateGrid(): void {
            const that = this;
            var gf = Gordic.Wfl.ListAC.WflListBaseAC.GetGridFormat();
            gf.addIconColumn(Gordic.Gin.Globals.GridIconOptResulInfo());
            gf.addIconColumn(Gordic.Wfl.ListPrefabs.IconZpusobDoruceni(this.ImageDelegateZpusobDoruceni));
            gf.addIconColumn(Gordic.Wfl.ListPrefabs.IconStavElPodani(this.ImageDelegateStavPodani));
            gf.addIconColumn(ListPrefabs.IconStavRozlozeni(this.ImageDelegateStavRozlozeni));
            gf.addIconColumn(Gordic.Wfl.ListPrefabs.DelegatePrizNearchFormat());
            if (this.model.EpaAutomat) gf.addIconColumn(ListPrefabs.DelegateRezimZpracovani());               

            //m_oGF.AddPictureColumn(GPodCommon.DelegateStavOdpovedi, "stav_odpovedi_img", title: GResources.GetResourceText(23900178)); 
                                                           
            gf.addIconColumn(Gordic.Wfl.ListPrefabs.DelegateElPodpisIcon());
            gf.addTextColumn(ListPrefabs.ixbColumn());
            gf.addDateTimeColumn(Gordic.Wfl.ListPrefabs.datPodaniColumn("jres:23900020")); //RC 23900020 : Datum dodání
            gf.addDateTimeColumn(Gordic.Wfl.ListPrefabs.datPrijetiColumn());      
            gf.addDateTimeColumn(Gordic.Wfl.ListPrefabs.datZpracovaniColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.stavPodaniColumn()); 
            gf.addTextColumn({ name: "stav_epod_txt", caption: "jres:23900026", width: 120, }) //RC 23900026 : Stav podání
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.ixpColumn());     
            //AddColumnZnacka();                    
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.mailFromColumn());
            gf.addDateTimeColumn({ name: "dat_odp", caption: "jres:23900046", width: 120, }) //RC 23900046 : Dat. potvrzení

            gf.addTextColumn(Gordic.Wfl.ListPrefabs.mailToColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.poznamkaColumn());    
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.mailboxColumn());
            gf.addTextColumn(ListPrefabs.IDZpravyColumn());
            if (this.PsrSKVisible) gf.addTextColumn(ListPrefabs.IDCorrelation());           
            gf.addTextColumn(ListPrefabs.UIDLColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.zpusobDoruceniColumn());
            gf.addTextColumn(ListPrefabs.nazevFunkceZpracovateleColumn());
            gf.addTextColumn(ListPrefabs.nazevFunkceZmenuProvedl());
            gf.addTextColumn({ name: "nazev_rf_akt", caption: "jres:23900227", width: 120, }) //RC 23900227 : Vlastník
            gf.addTextColumn({ name: "nazev_su_akt", caption: "jres:23900228", width: 120, }) //RC 23900228 : SU vlastníka
            gf.addDateTimeColumn(Gordic.Wfl.ListPrefabs.datDatZmenaColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.typDokumentuTxtColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.errorTextColumn());

            var OpenElPodani = new GAction({     //obsluzna akce, ktera se spousti dbl clickem nad radkem
                name: "gridRowSelectedAct",
                run: function (ev, ctx) {
                    var rowData = ctx.cellInfo.data; //data, ze kterych byl vytvoren radek
                    if (rowData.ixp)
                    {
                        var opt = {
                            DetailDto:
                            {
                                ixp: rowData.ixp
                            }
                        };
                        Gordic.Wfl.Dialogs.DetailDokumentuSpisu(that, opt);
                    }
                }
            })
            this.gridOptions = {};

            //this.gridOptions.searchColumns = ["ixb", "poznamka"];
            this.gridOptions.defaultAction = OpenElPodani;
            var grid = Gordic.Wfl.ListAC.WflListBaseAC.CreateGridBase(this, gf);
            this.mainGrid = grid;
            Gordic.Wfl.ListAC.WflListBaseAC.AfterCreateGrid(this);
        }

        LoadData(filtr?: Gordic.Wfl.Client.GElPodaniPrehledFilterDto)
        {           
            const that = this;
            Gin.Globals.ShowWaitLoadData(this);
            //nacteni dat do gridu
            this.call<Gordic.Wfl.Interface.GElPodaniDto[]>("LoadData", { "model": filtr})
                .done(function (data) {
                    var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                    that.mainGrid.ggrid("setData", view); 
                    //  } catch (e) { console.log("e", e) }

                })
                .always(function () {
                    Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that);
                });
        }

        ReloadData()
        {
            this.LoadData(this.model);
        }

        CreateActionOdstornovatElPodani(): GAction
        {
            const that = this;
            var action = new GAction({
                name: Pod.Globals.ActionsName.odstornovatElPodani,
                icon: Gordic.Gin.Icons.ActionEnum.odstornovat,
                caption: "jres:23900065", //RC 23900065 : Odstornovat el. podání
                run: function (ev, ctx)
                {
                    PodListBaseAC.DoAkceElPodani(that, Pod.Interface.TypAkceElPodani.odstornovat);
                }
            });
            return action;
        }

        CreateActionNastavitZpracovaniAutomat(): GAction {
            const that = this;
            var action = new GAction({
                name: Pod.Globals.ActionsName.odstornovatElPodani,
                icon: Gordic.Gin.Icons.ZpusobZpracovani.automaticky,
                caption: "jres:23900099", //RC 23900099 : Nastavit zpracování Automat
                run: function (ev, ctx) {
                    PodListBaseAC.DoAkceElPodani(that, Pod.Interface.TypAkceElPodani.nastavitZpracovaniAutomat);
                }
            });
            return action;
        }

        CreateActionNastavitZpracovaniManual(): GAction {
            const that = this;
            var action = new GAction({
                name: Pod.Globals.ActionsName.odstornovatElPodani,
                icon: Gordic.Gin.Icons.ZpusobZpracovani.rucne,
                caption: "jres:23900100", //RC 23900100 : Nastavit zpracování Manual
                run: function (ev, ctx) {
                    PodListBaseAC.DoAkceElPodani(that, Pod.Interface.TypAkceElPodani.nastavitZpracovaniManual);
                }
            });
            return action;
        }

        CreateActionPuvodniVzhledlElPodani(): GAction {
            const that = this;
            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.elPodani,
                icon: Gordic.Pod.Icons.ActionEnum.elPodani,
                caption: "jres:23900098", //RC 23900098 : Původní vzhled el. podání
                tooltip: "jres:23900098",
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx) {
                    var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(that);
                    if (rowData) {
                        var l_po: string[] = [];
                        l_po.push(rowData.ixb);
                        Gordic.Pod.Dialogs.EvidenceElPodaniDlg(that, { IxbArray: l_po, PouzePrehled: true }, Global.Enums.ModOtevreni.navigate)
                            .done(function (retVal: any) {
                                if (retVal && retVal.zobrazitDetailPozavreniPruvodce && retVal.pidDokumentu) { 
                                    var opt = {
                                        DetailDto:
                                        {
                                            ixp: retVal.pidDokumentu
                                        }
                                    };
                                    Gordic.Wfl.Dialogs.DetailDokumentuSpisu(that, opt);
                                }
                            }
                        );
                    }
                }
            });
            return action;
        }

        CreateActionVratitKeZpracovani(): GAction {
            const that = this;
            var action = new GAction({
                name: Pod.Globals.ActionsName.vratitElPodaniKeZpracovani,
                icon: Gordic.Pod.Icons.ActionEnum.vratitElPodaniKeZpracovani,
                caption: "jres:23900068", //RC 23900068 : Vrátit ke zpracování
                run: function (ev, ctx)
                {
                    PodListBaseAC.DoAkceElPodani(that, Pod.Interface.TypAkceElPodani.vratitKeZpracovani);
                }
            });
            return action;
        }
    }
}
